<template>
  <div class="activity">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
         <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
       <!-- 这里是会被缓存的视图组件，比如 Home！ -->
    </router-view>
  </div>

</template>

<script>
  export default {
    name: 'activity',
    data () {
      return {

      }
    },
    methods:{
    },
    mounted(){
    },

  }
</script>

<style>
  .activity{
      width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/activity.vue